import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { finalize, map } from 'rxjs/operators';

import { NameFormModel } from 'entity/forms/name-form/name-form.component';

import {
  EntityTypeDetails, GetEntityById2, GetEntityById2GQL, UpdateEntityBasicInfoGQL
} from 'generated/graphql';

/**
 * Format of data for the dialog
 */
export interface AddOrUpdateNameDialogData {
  entityId: string;
  campaignId: string;
  /**
   * If true the pronouns field is automatically
   * shown without click the "+ Add Pronouns" button
   */
  showPronounsOnLoad?: boolean;
}

@Component({
  selector: 'app-add-or-update-name-dialog',
  templateUrl: './add-or-update-name.dialog.html'
})
export class AddOrUpdateNameDialog implements OnInit {
  isSaving = false;

  /**
   * Set by dumb form component
   */
  formControl: UntypedFormControl;

  entityType: EntityTypeDetails.Fragment;

  constructor(
    private _getEntityById2GQL: GetEntityById2GQL,
    private _updateEntityBasicInfoGQL: UpdateEntityBasicInfoGQL,
    public dialogRef: MatDialogRef<AddOrUpdateNameDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AddOrUpdateNameDialogData
  ) { }

  static open(dialog: MatDialog, config: MatDialogConfig<AddOrUpdateNameDialogData>) {
    return dialog.open(AddOrUpdateNameDialog, config);
  }

  ngOnInit(): void {
    this._getDataAndBuildForm();
  }

  onSaveClicked() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    this._save$().pipe(
      finalize(() => this.isSaving = false)
    ).subscribe(({ data }) => {
      this.close(data.updateEntity);
    });
  }

  close(data: any = null) {
    this.dialogRef.close(data);
  }

  private _getDataAndBuildForm() {
    this._getEntityById2GQL.fetch({
      entityId: this.data.entityId,
      campaignId: this.data.campaignId
    }).pipe(
      map(({ data }) => data.getEntity)
    ).subscribe((entity) => {
      this.entityType = entity.entityType;
      this.formControl = new UntypedFormControl(
        this._toFormModel(entity)
      );
    });
  }

  private _save$() {
    const fv: NameFormModel = this.formControl.value;

    return this._updateEntityBasicInfoGQL.mutate({
      input: {
        entityId: this.data.entityId,
        campaignId: this.data.campaignId,
        changes: {
          firstName: fv.firstName,
          lastName: fv.lastName,
          middleName: fv.middleName,
          nickname: fv.nickname,
          pronouns: fv.pronouns,
          suffix: fv.suffix
        }
      }
    });
  }

  private _toFormModel(entity: GetEntityById2.GetEntity): NameFormModel {
    return {
      firstName: entity.firstName,
      lastName: entity.lastName,
      nickname: entity.nickname,
      middleName: entity.middleName,
      pronouns: entity.pronouns,
      suffix: entity.suffix,
    };
  }
}
